module.exports = __webpack_public_path__ + "static/MADECarvingSoft-Black-ef690705eafb59f6f917b63eb9adc136.woff2";